import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

const AccordionItemHeadingElement = styled.div``;

export default function AccordionItemHeading(props: HTMLAttributes<HTMLDivElement>): JSX.Element {
    const { className, children } = props;
    return <AccordionItemHeadingElement className={className}>{children}</AccordionItemHeadingElement>;
}
